<div class="grid-container margin-top">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12 medium-12 small-12">
      <text-loader [run]="dataLoading?.value == true" [text]="'Loading Adjustment Request'" [tickType]="'.'" [interval]="1000"></text-loader>
    </div>
  </div>
  @if (dataLoading?.value == false) {
    <div class="grid-x grid-margin-x">
      <div class="cell large-6 medium-6 small-6">
        <span class="bold padding-right">Requested By:</span>{{request?.requestedByName}}
      </div>
      <div class="cell large-6 medium-6 small-6">
        <span class="bold padding-right">Requested Date:</span>{{ request?.requestedDate | date}}
      </div>
      <div class="cell large-12 medium-12 small-12 bold">
        Proposed Adjustments:
      </div>
      <div class="cell large-12 medium-12 small-12 record-display">
        @for (adj of request?.paymentRecordAdjustments; track adj) {
          <div class="grid-x border-bottom-medium-gray">
            <div class="cell large-6 medium-6 small-6">
              <span class="bold padding-right">From Application:</span>{{adj.fromApplicationNumber}}
            </div>
            <div class="cell large-6 medium-6 small-6">
              <span class="bold padding-right">To Application:</span>{{adj.toApplicationNumber}}
            </div>
            <div class="cell large-6 medium-6 small-6">
              <span class="bold padding-right">From Payment:</span>{{adj.fromApplicationPaymentId}} - {{adj.fromPaymentDescription}}
            </div>
            <div class="cell large-6 medium-6 small-6">
              <span class="bold padding-right">To Payment:</span>{{adj.toApplicationPaymentId}} - {{adj.toPaymentDescription}}
            </div>
            <div class="cell large-6 medium-6 small-6">
              <span class="bold padding-right">Payment Instrument</span>{{adj.instrumentToken}}
            </div>
            <div class="cell large-6 medium-6 small-6">
              <span class="bold padding-right">Amount Reapplied:</span>{{adj.amountApplied | currency}}
            </div>
          </div>
        }
      </div>
      <div class="cell large-12 medium-12 small-12 margin-top">
        <adjustment-request-notes [notes]="request.paymentRecordAdjustmentNotes" [enabled]="true" (errorOccurred)="logError($event)" (noteAdded)="addNote($event)" (noteDeleted)="deleteNote($event)"></adjustment-request-notes>
      </div>
      <div class="cell large-12 medium-12 small-12 margin-top">
        <span class="bold">Supporting Documentation:</span>
      </div>
      <div class="cell large-12 medium-12 small-12">
        <upload-view-files [uniqueId]="'documents'" [files]="documentation" [isPadded]="false" [componentLabel]="' '" [showFileList]="true" [allowDeletion]="false" [allowUpload]="false"></upload-view-files>
      </div>
      <div class="cell large-12 medium-12 small-12 margin-top text-align-center">
        <span class="padding-right">
          <button (click)="save()" class="button" [disabled]="!canApprove">Save For Later</button>
        </span>
        <span class="padding-right">
          <button (click)="deny()" class="button" [disabled]="!canApprove">Deny Request</button>
        </span>
        <span class="padding-left">
          <button (click)="approve()" class="button" [disabled]="!canApprove">Approve Request</button>
        </span>
        @if (!canApprove && saveInProgress?.value == false) {
          <span class="padding-left italics">
            <span class="italic shrink-font">Why can't I approve?</span><help-text [helpText]="cantApproveText"></help-text>
          </span>
        }
      </div>
      @if (applicationPayments != null && (saveInProgress?.value == true || request.requestStatus == statuses.Pending)) {
        <div class="cell large-12 medium-12 small-12 margin-bottom">
          <span class="bold padding-right">Replacement receipts / invoices:</span> <span class="italic">*Invoices and receipts will be generated automatically when the adjustment is approved.</span>
        </div>
        @for (app of applicationList; track app) {
          <div class="cell large-2 medium-2 small-2">&nbsp;</div>
          <div class="cell large-8 medium-8 small-8">
            <reapplication-receipt
              [isPaid]="receiptIsPaid(app)"
              [applicationNumber]="app"
              [records]="getPaymentsByApplication(app)"
              [requestedDate]="request?.requestedDate"
              [adjustmentSources]="getAdjustmentsForApplication(app)"
              >
            </reapplication-receipt>
          </div>
          <div class="cell large-2 medium-2 small-2">&nbsp;</div>
        }
      }
    </div>
  }
</div>
<a href="" style="display:none" target="_blank" #downloadLink></a>